import { LayoutHOC } from 'base/ui/layout/layout';
import { createAddSerial } from './addSerial';

export const createAddSerialPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createAddSerial());
};
